<template>
  <div id="orders">
    <LoadingContainer v-if="loadingItems" />
    <div v-else>
      <EmptyState v-if="!items.length" :totalItemsRegistered="items.length">
        <template v-slot:noItemsRegistered>
          <span class="fa-3x far fa-calendar text-black-50 mb-2"></span>
          <p>Nenhuma notificação</p>
        </template>
      </EmptyState>
      <template v-else>
        <div class="list-group list-group-flush my-n3 px-2">
          <div
            class="list-group-item text-primary cursor-pointer"
            @click="handleDetail(item)"
            :class="{ 'bg-primary05': !item.read }"
            v-for="(item, index) in items"
          >
            <div class="row">
              <div class="col ms-n2">
                <h5 class="mb-1 fw-bold">
                  <span v-if="!item.read" class="fas fa-circle me-2"></span>
                  {{ item.title }}
                </h5>
                <p class="small mb-0">
                  {{ item.description }}
                </p>
                <small class="text-gray-700">
                  {{ item.created_at.toFormattedDate(1, true) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import NotificationsListController from "./NotificationsListController";
export default NotificationsListController;
</script>
<style scoped></style>
